// ItemSourceMeanValidator item workflow statuses
export enum ItemSourceMeanValidatorItemStatus {
  PENDING = 0,
  NEEDS_USER_REVIEW = 1,
  DONE = 2,
}

// ItemSourceMeanValidator parent statuses
export enum ItemSourceMeanValidatorStatus {
  PENDING = 0,
  NEEDS_USER_REVIEW = 1,
  DONE = 2,
}

// Shared async task status (same as backend AsyncTasksQueue)
export enum AsyncTaskStatus {
  PENDING = 0,
  DOING = 1,
  DONE = 2,
  FAILED = 3,
  DEAD_LETTER = 4,
  CANCELLED = 5,
  AWAITING_MEMORY = 6,
}

export const ItemSourceMeanValidatorStatusLabels: Record<ItemSourceMeanValidatorStatus, string> = {
  [ItemSourceMeanValidatorStatus.PENDING]: 'pending',
  [ItemSourceMeanValidatorStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ItemSourceMeanValidatorStatus.DONE]: 'done',
};

export const ItemSourceMeanValidatorItemStatusLabels: Record<ItemSourceMeanValidatorItemStatus, string> = {
  [ItemSourceMeanValidatorItemStatus.PENDING]: 'pending',
  [ItemSourceMeanValidatorItemStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ItemSourceMeanValidatorItemStatus.DONE]: 'done',
};